<div class="progress">
  <div class="progress__start-text">
    <span class="cp-gauge-percentual" ><p class="cp-gauge-text-percentual">{{value}}%</p></span>
    <svg class="progress__svg" width="120" height="120" viewBox="0 0 120 160">
      <circle class="progress__meter" cx="60" cy="0" [attr.r]="radius" stroke-width="32" />
      <circle class="progress__value" [style.stroke]="strokeColor" [style.strokeDasharray]="circumference" [style.strokeDashoffset]="dashoffset" cx="60" cy="0"
      [attr.r]="radius" stroke-width="32" />
    </svg>
  </div>
  <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12" style="width: 120; margin-top: -10px;">
      <span class="cp-gauge-start-text" [style.color]="strokeColor">{{startlegend}}</span>
      <span class="cp-gauge-end-text ">{{endlegend}}</span>
  </div>
</div>
